import { useCallback } from 'react';
import { useLogger } from '../../context';
import { useSignout } from '../useSignout';
import { FetchError } from './FetchError';
import { reportIfTokenExpired } from './reportIfTokenExpired';
import { FETCH_ERRORS } from './errors';
export function useFetch(tokenFetcher) {
    const { signout } = useSignout();
    const logger = useLogger();
    const request = useCallback(async (input, init = {}) => {
        const accessToken = await tokenFetcher();
        if (!accessToken) {
            logger.error(FETCH_ERRORS.noAccessToken, new Error('Failed to fetch access token'));
            throw new Error('Failed to fetch access token');
        }
        reportIfTokenExpired(accessToken, logger);
        const response = await fetch(input, {
            ...init,
            credentials: 'omit',
            headers: {
                ...init.headers,
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.status === 401) {
            logger.error(FETCH_ERRORS.userNotAuthorised, new Error(`User is not authorised for request: ${input.toString()}`));
            signout();
        }
        if (!response.ok) {
            throw new FetchError(response.statusText, response.status, response);
        }
        return response;
    }, [logger, signout, tokenFetcher]);
    return request;
}
